import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const chapterMembershipApi = generateNomenApi(`/chapter/chapter-membership`);

export const chapterMembershipOptions = generateNomenOptions('chapter-membership', chapterMembershipApi);
